import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import html2pdf from 'html2pdf.js';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import { getBankdetal, PropertyBookingCancle, Propertybookingpdf, Propertybookings, PropertyCancelReason, PropertyDynamicVoucher, PropertyVoucherSend } from '../../Services/Service';

import swal from "sweetalert";
import { useDispatch, useSelector } from 'react-redux';
import { PropresetPMSState, PropUpdatePMS } from '../../Redux/Slices/propPmsSlice';
import '../../reservation pages/Booking Details/BookingList.css';



const BookingList = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [showSuccess, setShowSuccess] = useState(false);
  const [bookingData, setBookingData] = useState([]);

  const [cancelCodes, setCancelCodes] = useState([]);
  const [selectedCode, setSelectedCode] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [bankFormData, setBankFormData] = useState(null);
  const [emails, setEmails] = useState([]);
  const [inputEmail, setInputEmail] = useState("");
  const [error, setError] = useState("");
  const [filters, setFilters] = useState({
    BookingDate: "",
    CompName: "",
    GuestName: "",
    CheckInDate: "",
    CheckOutDate: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 15;

  const { loading: pmsLoading, success } = useSelector((state) => state.PropPMS);

  const [pmsId, setPmsId] = useState("");

  useEffect(() => {
    const fetchBookings = async () => {
      setLoading(true);
      try {
        const data = await Propertybookings({});
        // setBookingData(data || []);
        setBookingData((data || []));
        setCurrentPage(1);
      } catch (error) {
        console.log("Error fetching bookings", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBookings();
  }, [])


  const handleFilter = async () => {
    setLoading(true);
    try {
      const data = await Propertybookings({
        BookingDate: filters.BookingDate,
        CompName: filters.CompName.trim(),
        GuestName: filters.GuestName.trim(),
        CheckInDate: filters.CheckInDate,
        CheckOutDate: filters.CheckOutDate,
      });

      setBookingData((data || []).reverse());
      setCurrentPage(1);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };


  const handleClear = async () => {
    setFilters({
      BookingDate: "",
      CompName: "",
      GuestName: "",
      CheckInDate: "",
      CheckOutDate: "",
    });

    const data = await Propertybookings({});
    setBookingData((data || []).reverse());
    setCurrentPage(1);
  };



  useEffect(() => {
    if (location.state?.showSuccess) {
      setShowSuccess(true);

      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [location.state]);

  useEffect(() => {
    const getBankdetails = async () => {
      setLoading(true);
      try {
        const result = await getBankdetal();
        if (result && result.length > 0) {
          setBankFormData(result[0]);
        }
      }
      catch (error) {
        console.log("error get bank details", error);
      } finally {
        setLoading(false);
      }
    }
    getBankdetails();
  }, []);



  const handleGenerateVoucher = async (bonResId) => {
    try {
      setLoading(true);

      const data = await PropertyDynamicVoucher(bonResId);
      const url = data?.url;

      if (!url) {
        alert("Voucher URL not found");
        return;
      }

      // ✅ Open the voucher in a new tab
      window.open(url, "_blank");

    } catch (error) {
      console.error("Voucher open failed:", error);
      alert("Failed to open voucher");
    } finally {
      setLoading(false);
    }
  };


  // useEffect(() => {
  //   if (bookingData.length > 0 && window.$) {
  //     setTimeout(() => {
  //       window.$(".basic-datatables").DataTable({
  //         destroy: true,
  //       });
  //     }, 0);
  //   }
  // }, [bookingData]);


  // Booking Cancel reason Function
  useEffect(() => {
    const fetchCancelReason = async () => {
      try {
        const result = await PropertyCancelReason();
        // console.log("reason data", result);
        setCancelCodes(result || []);
      }
      catch (error) {
        console.log("error fetching cancel resons in Booking list page", error);
      }
    }
    fetchCancelReason();
  }, []);

  const handleCodeChange = (e) => {
    const code = e.target.value;
    setSelectedCode(code);

    const selected = cancelCodes.find((c) => c.Code === code);
    if (selected) {
      setCancelReason(selected.Description);
    } else {
      setCancelReason("");
    }
  };

  // reset form
  const resetCancelForm = () => {
    setSelectedCode("");
    setCancelReason("");
    setSelectedBooking(null);
  };

  // booking cancle
  const handleCancelBooking = async (item) => {

    if (!selectedCode) {
      alert("Please select a cancellation code.");
      return;
    }

    if (!cancelReason) {
      alert("Please enter a reason.");
      return;
    }

    setLoading(true);
    try {
      const result = await PropertyBookingCancle(item.BONRESID, item.PropertyID, selectedCode, cancelReason);

      if (result && result.BONRESID) {
        swal("Booking cancelled successfully!", {
          icon: "success",
          buttons: {
            confirm: {
              text: "OK",
              className: "btn btn-success",
            },
          },
        }).then(() => {

          const modal = window.bootstrap.Modal.getInstance(
            document.getElementById("Cancel-Booking-Resion")
          );
          if (modal) modal.hide();

          resetCancelForm(); // reset fields
        });

        // Table update: remove cancelled booking ya fetch list again
        setBookingData((prev) =>
          prev.map((b) =>
            b.BONRESID === item.BONRESID ? { ...b, BookingStatus: "Cancelled" } : b
          )
        );

      } else {
        alert(result?.message || "Failed to cancel booking");
      }
    } catch (error) {
      console.error(error);
      alert("Error cancelling booking");
    } finally {
      setLoading(false);
    }

  };


  const isValidEmail = (value) => {
    const email = value.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const addEmail = (value) => {
    if (!value) return false;

    const parts = value
      .split(/[\s,;]+/)
      .map(p => p.trim())
      .filter(Boolean);

    let addedAny = false;

    for (let p of parts) {
      if (!isValidEmail(p)) {
        setError(`Invalid email: ${p}`);
        return false;
      }
      if (!emails.includes(p)) {
        setEmails(prev => [...prev, p]);
        addedAny = true;
      }
    }

    setInputEmail("");
    setError("");
    return addedAny;
  };

  const removeEmail = (emailToRemove) => {
    setEmails(prev => prev.filter(e => e !== emailToRemove));
  };

  const editEmail = (emailToEdit) => {
    setInputEmail(emailToEdit);
    setEmails(prev => prev.filter(e => e !== emailToEdit));
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text");
    if (paste && /[,;\s]/.test(paste)) {
      e.preventDefault();
      addEmail(paste);
    }
  };


  const handleSendVoucher = async () => {
    if (!selectedBooking) {
      alert("No booking selected!");
      return;
    }

    // Single email auto add
    if (inputEmail) {
      const added = addEmail(inputEmail);
      if (!added) return;
    }

    if (emails.length === 0) {
      alert("Please enter at least one email!");
      return;
    }

    const id = selectedBooking.BONRESID;
    const EmailID = emails.join(",");

    try {
      setLoading(true);
      const response = await PropertyVoucherSend(id, EmailID);

      if (response?.url) {
        alert("Voucher sent successfully!");

        const modalEl = document.getElementById("zoomInModal");
        const modal =
          window.bootstrap.Modal.getInstance(modalEl) ||
          new window.bootstrap.Modal(modalEl);
        modal.hide();

        setEmails([]);
        setInputEmail("");
      } else {
        alert("Failed to send voucher!");
      }
    } catch (err) {
      console.error(err);
      alert("Failed to send voucher!");
    } finally {
      setLoading(false);
    }
  };



  const handleUpdatePMS = () => {
    if (!pmsId) {
      alert("Please enter PMS ID");
      return;
    }

    if (!selectedBooking) {
      alert("No booking selected");
      return;
    }

    dispatch(
      PropUpdatePMS({
        BONRESID: selectedBooking.BONRESID,
        PMSRESID: pmsId,
      })

    );
  };

  useEffect(() => {
    if (success) {
      swal("PMS Update Successfully", {
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-success",
          },
        },
      }).then(() => {
        // modal close
        const modalEl = document.getElementById("UpdatePMS");
        const modal =
          window.bootstrap.Modal.getInstance(modalEl) ||
          new window.bootstrap.Modal(modalEl);

        modal.hide();

        setPmsId("");

        // table update
        setBookingData((prev) =>
          prev.map((b) =>
            b.BONRESID === selectedBooking.BONRESID
              ? { ...b, PMSRESID: pmsId }
              : b
          )
        );

        dispatch(PropresetPMSState());
      });
    }

    if (error) {
      alert(error);
      dispatch(PropresetPMSState());
    }
  }, [success, error]);


  const totalRows = bookingData.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  const safeCurrentPage = Math.min(currentPage, totalPages);
  const firstRow = totalRows === 0 ? 0 : ((safeCurrentPage - 1) * rowsPerPage) + 1;
  const lastRow = Math.min(safeCurrentPage * rowsPerPage, totalRows);
  const visibleBookings = bookingData.slice(firstRow ? firstRow - 1 : 0, lastRow);
  const pageStart = Math.min(
    Math.max(safeCurrentPage - 1, 1),
    Math.max(totalPages - 2, 1)
  );
  const visiblePages = Array.from(
    { length: Math.min(3, totalPages) },
    (_, index) => pageStart + index
  );

  return (
    <>
      <style>{`
         
        tr th{
           font-size: 12px !important;
        }
           label{
             font-weight:bold !important;
           }

           .booking-filter-form .card-body .d-flex > div {
            flex: 0 0 auto;
            max-width: none;
          }

      @media (max-width: 768px) {
        .booking-filter-form .card-body .d-flex {
          flex-wrap: wrap;
          gap: 0.75rem;
          align-items: flex-start;
        }

  .booking-filter-form .card-body .d-flex > div {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .booking-filter-form .card-body .d-flex > div .btn {
    min-width: 110px;    
  }

  @media (max-width: 420px) {
    .booking-filter-form .card-body .d-flex > div:last-child {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .booking-filter-form .card-body .d-flex > div:last-child .btn {
      width: 100%;
      min-width: unset;
    }
  }

  .booking-filter-form .card-body .form-label {
    font-size: 0.92rem;
  }
}

.booking-filter-form .card-body .form-control {
  box-sizing: border-box;
  width: 100%;
}

.badge {    
    margin-left: initial;
      }

      
    `}</style>

      {loading && (
        <FullScreenLoader />
      )}

      <div className="wrapper ">
        <SideBar />
        <div className="main-panel">
          <Hearder />

          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">

                  <div className='card booking-filter-form mb-3'>
                    <form className='card-body'>
                      <div className='booking-filter-grid'>
                        <div className="booking-filter-field">
                          <label className='form-label'>Booking Date</label>
                          <input
                            className='form-control'
                            type='date'
                            value={filters.BookingDate}
                            onChange={(e) =>
                              setFilters({ ...filters, BookingDate: e.target.value })
                            }
                          />
                        </div>

                        <div className="booking-filter-field">
                          <label className='form-label'>Guest Name</label>
                          <input
                            className='form-control'
                            type='text'
                            placeholder='Enter Guest name'
                            value={filters.GuestName}
                            onChange={(e) =>
                              setFilters({ ...filters, GuestName: e.target.value })
                            }
                          />
                        </div>

                        <div className="booking-filter-field">
                          <label className='form-label'>Company name</label>
                          <input
                            className='form-control'
                            type='text'
                            placeholder='Enter Company name'
                            value={filters.CompName}
                            onChange={(e) =>
                              setFilters({ ...filters, CompName: e.target.value })
                            }
                          />
                        </div>

                        <div className="booking-filter-field">
                          <label className='form-label'>Check-In</label>
                          <input
                            className='form-control'
                            type='date'
                            value={filters.CheckInDate}
                            onChange={(e) =>
                              setFilters({ ...filters, CheckInDate: e.target.value })
                            }
                          />
                        </div>

                        <div className="booking-filter-field">
                          <label className='form-label'>Check-Out</label>
                          <input
                            className='form-control'
                            type='date'
                            value={filters.CheckOutDate}
                            onChange={(e) =>
                              setFilters({ ...filters, CheckOutDate: e.target.value })
                            }
                          />
                        </div>

                        <div className='booking-filter-actions'>
                          <button
                            className='btn btn-outline-danger'
                            type='button'
                            onClick={handleClear}
                          >
                            Clear
                          </button>

                          <button
                            className='btn btn-primary'
                            type='button'
                            onClick={handleFilter}
                          >
                            Filter Results
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>


                  {showSuccess && (
                    <div className="alert alert-success d-flex align-items-center" role="alert">
                      <i className="feather-check-circle flex-shrink-0 me-2"></i>
                      <div>Your booking details submitted to Hotel!</div>
                    </div>
                  )}


                  <div className="card booking-list-card">
                    <div className="card-header booking-list-header">
                      <h4 className="card-title mb-0">Booking List</h4>

                    </div>
                    <div className="card-body p-0">
                      <div className="table-responsive booking-list-table-wrap">
                        <table
                          // id="basic-datatables"
                          className="display table  table-bordered table-striped table-hover basic-datatables"
                        // style={{ width: '100%', tableLayout: 'auto' }}
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "4%" }}>Sr#</th>
                              <th style={{ width: "10%" }}>BON REF. Id</th>
                              <th style={{ width: "10%" }}>Conf. No</th>
                              <th style={{ width: "8%" }}>Check-in</th>
                              <th style={{ width: "8%" }}>Check-out</th>
                              <th style={{ width: "20%" }}>Guest Info</th>
                              <th style={{ width: "12%" }}>Mobile No</th>
                              <th style={{ width: "8%" }}>Payment</th>
                              <th style={{ width: "8%" }}>Status</th>
                              <th style={{ width: "9%" }}>Book On</th>
                              <th style={{ width: "3%" }}>Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {visibleBookings.map((item, index) => (
                              <tr key={item.ID}>
                                <td>{firstRow + index}</td>
                                <td className="booking-reference">{item.BONRESID}</td>
                                <td>{item.PMSRESID}</td>
                                <td>{item.CheckInDate}</td>
                                <td> {item.CheckOutDate}</td>
                                <td>
                                  <b>{item.GuestName}</b>
                                  <div>{item.CompanyName}</div>
                                  <div>Email: {(() => {
                                    try {
                                      const gd = JSON.parse(item.GuestDetails);
                                      return gd?.[0]?.EMailAddress || "N/A";
                                    } catch {
                                      return "N/A";
                                    }
                                  })()}</div>
                                </td>
                                <td>
                                  {(() => {
                                    try {
                                      const gd = JSON.parse(item.GuestDetails);
                                      return gd?.[0]?.MobileNumber || "N/A";
                                    } catch {
                                      return "N/A";
                                    }
                                  })()}
                                </td>

                                <td>
                                  <div> <span > ₹ {item.TotalPayment} </span></div>
                                  <div>
                                    <span
                                      className={
                                        item.PaymentStatus === "Paid"
                                          ? "text-success"
                                          : item.PaymentStatus === "Pending"
                                            ? "text-warning"
                                            : "text-secondary"
                                      }
                                    >
                                      {item.PaymentStatus || "N/A"}
                                    </span>
                                  </div>
                                </td>

                                <td className="text-center">
                                  <span
                                    className={
                                      item.BookingStatus === "Confirmed"
                                        ? "text-success"
                                        : item.BookingStatus === "Pending"
                                          ? "text-warning"
                                          : item.BookingStatus === "Cancelled"
                                            ? "text-danger"
                                            : "text-secondary"
                                    }
                                  >
                                    {item.BookingStatus || "N/A"}
                                  </span>
                                </td>
                                <td>{item.BookingDate}</td>
                                <td className="text-center">
                                  <div className="dropdown dropdown-action">
                                    <a href="" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false" >
                                      <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right" >
                                      {/* <button type='button' className="dropdown-item" onClick={() => handleModifyClick(item)}><i className='fas fa-edit me-1'></i> Modify </button> */}
                                      <a href='/Property/EditBooking' className="dropdown-item" ><i className='fas fa-edit me-1'></i> Modify </a>
                                      {item.BookingStatus !== "Cancelled" && item.BookingStatus !== "Pending" && (

                                        <button type="button" className="dropdown-item" data-bs-toggle="modal"
                                          data-bs-target="#Cancel-Booking-Resion" onClick={() => {
                                            setSelectedBooking(item); setSelectedCode(""); // reset code
                                            setCancelReason("");
                                          }} ><i className='fas fa-ban me-2'></i>Cancelled</button>
                                      )}

                                      {/* <button className="dropdown-item" onClick={() => handleGenerateVoucher(item)} > <i className="fas fa-sticky-note me-2"></i> Booking Voucher </button> */}
                                      <button className="dropdown-item" onClick={() => handleGenerateVoucher(item.BONRESID)}> <i className="fas fa-sticky-note me-2"></i> Booking Voucher </button>
                                      <button type="button" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#zoomInModal" onClick={() => setSelectedBooking(item)}><i className='fas fa-envelope me-2'></i>Send Voucher</button>
                                      <NavLink to={`/Property/VoucherDetail/${item.BONRESID}`} className="dropdown-item " style={{ color: "#333", padding: "2px 14px", background: "none" }}><i className="fa fa-info-circle me-2"></i>Voucher Details</NavLink>
                                      {item.BookingStatus === "Pending" && (<button type="button" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#UpdatePMS" onClick={() => {
                                        setSelectedBooking(item);
                                        setPmsId("");
                                      }}><i className='fas fa-envelope me-2'></i>Update PMS ID</button>)}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="booking-pagination">
                        <span>
                          Showing {firstRow} to {lastRow} of {totalRows} entries
                        </span>
                        <nav aria-label="Booking list pagination">
                          <button
                            type="button"
                            aria-label="Previous page"
                            disabled={safeCurrentPage === 1}
                            onClick={() => setCurrentPage(page => Math.max(1, page - 1))}
                          >
                            ‹
                          </button>
                          {visiblePages.map(page => (
                            <button
                              type="button"
                              key={page}
                              className={page === safeCurrentPage ? "active" : ""}
                              aria-current={page === safeCurrentPage ? "page" : undefined}
                              onClick={() => setCurrentPage(page)}
                            >
                              {page}
                            </button>
                          ))}
                          <button
                            type="button"
                            aria-label="Next page"
                            disabled={safeCurrentPage === totalPages}
                            onClick={() => setCurrentPage(page => Math.min(totalPages, page + 1))}
                          >
                            ›
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            id="Cancel-Booking-Resion"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title" id="exampleModalLabel">
                    Booking Cancel
                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">

                  <div className="mb-3">
                    <label className="col-form-label">Code:</label>
                    <select className="form-control form-select" value={selectedCode}
                      onChange={handleCodeChange}>
                      <option>Select Code</option>
                      {cancelCodes.map((c) => (
                        <option key={c.Code} value={c.Code}>
                          {c.Code}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="" className="col-form-label">
                      Cancel Reason:
                    </label>
                    <textarea className="form-control" value={cancelReason}
                      onChange={(e) => setCancelReason(e.target.value)} />
                  </div>

                </div>
                <div className="modal-footer">
                  <button type="button" onClick={() => handleCancelBooking(selectedBooking)} className="btn btn-danger">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>

          <>
            {/* Modal Blur */}
            <div
              id="zoomInModal"
              className="modal fade zoomIn"
              tabIndex={-1}
              aria-labelledby="zoomInModalLabel"
              aria-hidden="true"
              style={{ display: "none" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="zoomInModalLabel">
                      Send Voucher
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-12">
                        {/* inside your modal-body */}
                        <div className="email-input-wrapper form-control d-flex  gap-2" style={{ minHeight: "42px" }}>
                          {emails.map((email, index) => (
                            <span
                              key={index}
                              className="badge bg-primary align-items-center"
                              style={{ cursor: "pointer" }}
                              onClick={() => editEmail(email)}
                              title="Click to edit"
                            >
                              {email}
                              <button
                                className="btn-close btn-close-white ms-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  removeEmail(email);
                                }}
                              />
                            </span>
                          ))}

                          <input
                            type="text"
                            value={inputEmail}
                            onChange={(e) => { setInputEmail(e.target.value); if (error) setError(""); }}

                            onPaste={handlePaste}
                            placeholder={emails.length === 0 ? "Enter Email Address" : ""}
                            className="border-0 "
                            style={{ outline: "none", minWidth: "200px" }}
                          />
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-warning"
                      onClick={() => inputEmail && addEmail(inputEmail)}
                    >
                      Add More
                    </button>

                    <button type="button" className="btn btn-primary" onClick={handleSendVoucher}>
                      Send
                    </button>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
          </>

          <>
            <div
              id="UpdatePMS"
              className="modal fade zoomIn"
              tabIndex={-1}
              aria-labelledby="zoomInModalLabel"
              aria-hidden="true"
              style={{ display: "none" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="zoomInModalLabel">
                      Update PMS
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-12">
                        <input type="text" className="form-control" placeholder='Enter...' value={pmsId} onChange={(e) => setPmsId(e.target.value)} />
                      </div>
                    </div>

                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={handleUpdatePMS}>
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>


        </div>

      </div>

    </>
  );
};

export default BookingList;
